import { render, staticRenderFns } from "./PublicationSuccess.vue?vue&type=template&id=13e8cd0a&scoped=true&"
import script from "./PublicationSuccess.vue?vue&type=script&lang=js&"
export * from "./PublicationSuccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e8cd0a",
  null
  
)

export default component.exports